import { Observable } from "rxjs";
import { formatMessage } from "lib/globalize-util";
import "rxjs/add/operator/map";
import { COLLECTIONS } from "constants/action-types";
import { SizingErrors, SizeRangesErrors } from "constants/product-collection";
import { setAssortmentError } from "actions/collections";
import { get } from "lodash";

const assortmentErrosHash: string[] = [
    SizingErrors.CurveNotFound,
    SizingErrors.DoorCurveNotFound,
    SizingErrors.SizeTotalsDotNotMatchBulks,
    SizeRangesErrors.SizeRangesDoNotMatch,
    SizeRangesErrors.SizeRangesNotFound,
];

export const lookupAssortmentErrorsEpic = (action$, store) =>
    action$
        .ofType(COLLECTIONS.COLLECTION.ERROR.ALLOCATION_LOOK_UP_ERROR)
        .map(({ payload }) => payload)
        .switchMap(({ assortmentsData = [] }) => {
            let hasAssoermentError = false;

            if (!assortmentsData || !assortmentsData.length) {
                const {
                    collection: { gridApi },
                } = store.getState();
                let fieldNames = [];

                const ids = [];
                gridApi.forEachNode(({ data }) => {
                    // Only allocate node that is NOT proxy OR first proxy (index=0) to prevent duplicate
                    if (data && !data.proxyIndex) {
                        ids.push(data.fields.id.string_value);
                    }
                });

                hasAssoermentError = ids.some((id) => {
                    const { data } = gridApi.getRowNode(id);
                    if (!fieldNames.length) {
                        fieldNames = Object.keys(data.fields);
                    }
                    return fieldNames.some((key) =>
                        assortmentErrosHash.includes(get(data, ["fields", key, "string_value"])),
                    );
                });
            } else {
                hasAssoermentError = assortmentsData.some((assortmentData) => {
                    return Object.keys(assortmentData).some((key) => assortmentErrosHash.includes(assortmentData[key]));
                });
            }

            return Observable.of(
                setAssortmentError(
                    hasAssoermentError ? formatMessage("This assortment contains one or more errors.") : null,
                ),
            );
        });
